import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import { PENDING_INVITES, ROLE_CONFIG } from './teamData';

function RoleBadge({ role }) {
  const cfg = ROLE_CONFIG?.[role] || ROLE_CONFIG?.Viewer;
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full font-caption text-xs font-semibold ${cfg?.color}`}>{role}</span>;
}

function StatusBadge({ status }) {
  const map = { Pending: 'bg-amber-100 text-amber-700', Expired: 'bg-red-100 text-red-700', Accepted: 'bg-green-100 text-green-700' };
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full font-caption text-xs font-semibold ${map?.[status] || 'bg-muted text-muted-foreground'}`}>{status}</span>;
}

export default function PendingInvitesTab({ isAdmin, showToast }) {
  const [invites, setInvites] = useState(PENDING_INVITES);

  const handleRevoke = (id) => {
    setInvites(prev => prev?.filter(i => i?.id !== id));
    showToast('Invitation revoked');
  };

  const isExpiringSoon = (expiryMs) => expiryMs - Date.now() < 24 * 3600000;

  return (
    <div>
      <div className="bg-card rounded-2xl border border-border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[700px]">
            <thead>
              <tr className="bg-muted border-b border-border">
                {['Invitee Email', 'Role', 'Invited By', 'Organisation', 'Date Sent', 'Expiry', 'Status', 'Actions']?.map(col => (
                  <th key={col} className="px-4 py-3 text-left font-caption text-xs font-semibold text-muted-foreground uppercase tracking-wide">{col}</th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-border/50">
              {invites?.map(invite => (
                <tr key={invite?.id} className="hover:bg-muted transition-colors">
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center">
                        <Icon name="Mail" size={13} color="var(--color-muted-foreground)" />
                      </div>
                      <span className="font-caption text-sm font-medium text-foreground">{invite?.email}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3"><RoleBadge role={invite?.role} /></td>
                  <td className="px-4 py-3 font-caption text-sm text-muted-foreground">{invite?.invitedBy}</td>
                  <td className="px-4 py-3 font-caption text-sm text-muted-foreground">{invite?.organisation}</td>
                  <td className="px-4 py-3 font-caption text-sm text-muted-foreground">{invite?.dateSent}</td>
                  <td className="px-4 py-3">
                    <span className={`font-caption text-sm font-medium ${isExpiringSoon(invite?.expiryMs) ? 'text-red-600' : 'text-muted-foreground'}`}>
                      {invite?.expiryDate}
                      {isExpiringSoon(invite?.expiryMs) && <Icon name="AlertCircle" size={13} className="inline ml-1" color="#dc2626" />}
                    </span>
                  </td>
                  <td className="px-4 py-3"><StatusBadge status={invite?.status} /></td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-1">
                      {isAdmin && (
                        <button
                          onClick={() => showToast(`Invite resent to ${invite?.email}`)}
                          className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg font-caption text-xs font-medium text-primary bg-primary/8 hover:bg-primary/15 border border-primary/20 transition-colors"
                        >
                          <Icon name="Send" size={12} />
                          Resend
                        </button>
                      )}
                      {isAdmin && (
                        <button
                          onClick={() => handleRevoke(invite?.id)}
                          className="flex items-center gap-1 px-2.5 py-1.5 rounded-lg font-caption text-xs font-medium text-red-600 bg-red-50 hover:bg-red-100 border border-red-200 transition-colors"
                        >
                          <Icon name="XCircle" size={12} />
                          Revoke
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {invites?.length === 0 && (
                <tr><td colSpan={8} className="px-4 py-12 text-center font-caption text-muted-foreground text-sm">No pending invitations.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
